export default "__VITE_ASSET__0bbdb0c0__"